import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type WatchNowOfferFragment = {
	__typename: 'Offer';
	id: string;
	standardWebURL?: string | null;
	preAffiliatedStandardWebURL?: string | null;
	streamUrl?: string | null;
	streamUrlExternalPlayer?: string | null;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	lastChangeRetailPriceValue?: number | null;
	currency?: string | null;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	availableTo?: any | null;
	dateCreated?: any | null;
	newElementCount?: number | null;
	mediaDealId?: number | null;
	package: {
		__typename?: 'Package';
		id: string;
		icon: string;
		packageId: number;
		clearName: string;
		shortName: string;
		technicalName: string;
		iconWide: string;
		hasRectangularIcon: boolean;
	};
};

export type NewWatchNowOfferFragment = {
	__typename: 'Offer';
	lastChangeRetailPrice?: string | null;
	lastChangePercent?: number | null;
	id: string;
	standardWebURL?: string | null;
	preAffiliatedStandardWebURL?: string | null;
	streamUrl?: string | null;
	streamUrlExternalPlayer?: string | null;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	lastChangeRetailPriceValue?: number | null;
	currency?: string | null;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	availableTo?: any | null;
	dateCreated?: any | null;
	newElementCount?: number | null;
	mediaDealId?: number | null;
	package: {
		__typename?: 'Package';
		id: string;
		icon: string;
		packageId: number;
		clearName: string;
		shortName: string;
		technicalName: string;
		iconWide: string;
		hasRectangularIcon: boolean;
	};
};

export const WatchNowOfferFragmentDoc = gql`
	fragment WatchNowOffer on Offer {
		__typename
		id
		standardWebURL
		preAffiliatedStandardWebURL
		streamUrl
		streamUrlExternalPlayer
		package {
			id
			icon
			packageId
			clearName
			shortName
			technicalName
			iconWide(profile: S160)
			hasRectangularIcon(country: $country, platform: WEB)
		}
		retailPrice(language: $language)
		retailPriceValue
		lastChangeRetailPriceValue
		currency
		presentationType
		monetizationType
		availableTo
		dateCreated
		newElementCount
		mediaDealId
	}
`;
export const NewWatchNowOfferFragmentDoc = gql`
	fragment NewWatchNowOffer on Offer {
		...WatchNowOffer
		lastChangeRetailPrice(language: $language)
		lastChangePercent
	}
	${WatchNowOfferFragmentDoc}
`;
